var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2Day(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3000 216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-2",
    serifId: "layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.002,84.176l-0.002,128.622l3000,2.324l-0,-127.362l-3000,-3.584Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.002,84.176l-0.002,128.622l3000,2.324l-0,-127.362l-3000,-3.584Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2959.64,157.676c0.753,0.069 1.318,0.719 1.283,1.474c-0.035,0.755 -0.657,1.35 -1.413,1.35c-108.544,-0.011 -456.449,-0.047 -667.89,-0.069c-1.414,-0.01 -2.565,-1.142 -2.597,-2.556c-0.033,-1.414 1.064,-2.598 2.476,-2.674c0.004,-0.001 0.009,-0.001 0.013,-0.001c29.443,-1.578 58.222,-4.593 88.707,-4.779c31.949,-0.195 61.236,3.889 92.277,4.981c73.409,2.582 141.969,-6.863 208.841,-3.216c73.416,4.005 131.966,-0.626 181.46,-0.125c25.655,0.26 67.544,3.263 96.843,5.615Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.8,119.478c1.035,0.08 1.822,0.963 1.782,2c-0.04,1.037 -0.892,1.857 -1.93,1.857c-121.261,-0.011 -451.167,-0.045 -654.666,-0.066c-1.414,-0.011 -2.564,-1.143 -2.597,-2.557c-0.033,-1.413 1.064,-2.597 2.476,-2.673c0.004,-0.001 0.009,-0.002 0.013,-0.002c29.443,-1.578 58.222,-4.593 88.708,-4.779c31.948,-0.194 61.236,3.89 92.277,4.981c73.408,2.582 141.968,-6.862 208.84,-3.215c73.416,4.004 131.966,-0.626 181.46,-0.125c22,0.222 55.937,2.463 83.637,4.579Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3142.51,127.067c2.286,0.111 4.065,2.026 4.009,4.313c-0.055,2.288 -1.926,4.113 -4.214,4.113c-152.055,-0.019 -404.408,-0.045 -571.519,-0.062c-1.414,-0.01 -2.564,-1.142 -2.597,-2.556c-0.032,-1.414 1.064,-2.598 2.476,-2.674c0.005,-0.001 0.009,-0.001 0.014,-0.001c29.442,-1.578 58.222,-4.593 88.707,-4.779c31.948,-0.195 61.236,3.889 92.277,4.981c73.408,2.582 141.969,-6.863 208.841,-3.216c73.416,4.005 131.966,-0.626 181.459,-0.125c0.182,0.002 0.364,0.004 0.547,0.006Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.58
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "trees-1",
    serifId: "trees 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1840.38,10c0,-0 46.128,85.047 58.519,107.893c0.636,1.174 0.608,2.595 -0.075,3.742c-0.683,1.147 -1.919,1.85 -3.254,1.85c-12.763,0 -41.15,0 -51.403,0c-1.004,0 -1.968,-0.399 -2.678,-1.109c-0.71,-0.71 -1.109,-1.673 -1.109,-2.677c0,-19.714 0,-109.699 0,-109.699Z",
    style: {
      fill: "#ffe8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.27,42.699l-0,80.786c-0,0 -24.283,0 -36.059,0c-1.325,0 -2.554,-0.693 -3.24,-1.826c-0.686,-1.134 -0.729,-2.544 -0.114,-3.717c9.555,-18.242 39.413,-75.243 39.413,-75.243Z",
    style: {
      fill: "#ffd16c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.27,5.189c-0.001,-1.592 -1.291,-2.883 -2.884,-2.883c-0.001,-0 -0.002,-0 -0.004,-0c-1.592,-0 -2.883,1.291 -2.883,2.883c0,18.315 0,118.257 0,136.571c0,1.593 1.291,2.883 2.883,2.883c0.002,0 0.003,0 0.004,0c1.593,0 2.883,-1.29 2.884,-2.883c-0,-18.314 -0,-118.256 -0,-136.571Z",
    style: {
      fill: "#e47422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.12,139.899c-1.29,-0.986 -1.809,-2.685 -1.289,-4.223c0.52,-1.538 1.963,-2.573 3.587,-2.573c22.638,-0 73.079,-0 89.395,-0c1.21,-0 2.348,0.578 3.06,1.557c0.713,0.979 0.915,2.239 0.543,3.391c-1.023,3.172 -2.31,7.164 -3.14,9.739c-0.505,1.564 -1.961,2.624 -3.604,2.624c-12.623,-0 -64.657,-0 -73.501,-0c-0.831,-0 -1.638,-0.273 -2.298,-0.777c-2.247,-1.716 -7.822,-5.973 -12.753,-9.738Z",
    style: {
      fill: "#e47422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.38,4.831c6.169,-4.764 14.948,-6.045 22.342,-3.663c5.867,1.891 9.743,6.095 17.049,7.226c3.622,0.561 8.1,0.186 10.578,-0.108c0.292,-0.037 0.577,0.109 0.717,0.369c0.139,0.26 0.104,0.579 -0.089,0.802c-2.752,2.834 -9.949,8.923 -21.01,8.616c-14.339,-0.399 -18.111,-11.888 -29.2,-8.061",
    style: {
      fill: "#e47422"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2138.04,141.988c2.286,0.111 4.065,2.026 4.009,4.313c-0.055,2.288 -1.926,4.113 -4.214,4.113c-152.055,-0.019 -404.408,-0.045 -571.519,-0.062c-1.414,-0.01 -2.564,-1.142 -2.597,-2.556c-0.032,-1.414 1.064,-2.598 2.476,-2.674c0.005,-0.001 0.009,-0.001 0.014,-0.001c29.442,-1.578 58.222,-4.593 88.707,-4.779c31.948,-0.195 61.236,3.889 92.277,4.981c73.408,2.582 141.969,-6.863 208.841,-3.216c73.416,4.005 131.966,-0.626 181.459,-0.125c0.182,0.002 0.364,0.004 0.547,0.006Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.58
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.08333,181.712,-181.712,2.08333,1664.58,2.27374e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007182",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08dcfc",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2Day);
export default __webpack_public_path__ + "static/media/layer2-day.e6a2e43262544741b62769cf74ac8e75.svg";
export { ForwardRef as ReactComponent };